// ╭────────────────────────────────────────────────────────────────────────────────────╮
// ┊  This file was automatically generated
// ┊  Please do not modify manually
// ┊  ©gl it 2025 - http://www.gl-it.ch
// ╰────────────────────────────────────────────────────────────────────────────────────╯

import Vue from 'vue';
import { wrapResponseWithDataRecord } from '@glittr/frontend-core/src/core/v2/data/data-record';
import { Servicelayer } from '@glittr/frontend-core/src/plugins/servicelayer';
import RequestConfig from '@glittr/frontend-core/src/plugins/servicelayer/requestConfig';
import GetWidgetHostConfigAsyncRequestModel from '../../model/get-widget-host-config-async-request-model';
import CreateWidgetHostConfigRequestModel from '../../model/create-widget-host-config-request-model';
import GetWidgetHostConfigByIdAsyncRequestModel from '../../model/get-widget-host-config-by-id-async-request-model';
import UpdateWidgetHostConfigRequestModel from '../../model/update-widget-host-config-request-model';
import DeleteWidgetHostConfigRequestModel from '../../model/delete-widget-host-config-request-model';
import WidgetHostConfigPagingResultModel from '../../model/widget-host-config-paging-result-model';
import WidgetHostConfigModel from '../../model/widget-host-config-model';

export default (service: Servicelayer) => ({
  /**  */
  async getWidgetHostConfigAsync(request: GetWidgetHostConfigAsyncRequestModel, config?: RequestConfig) {
    const requestDTO = GetWidgetHostConfigAsyncRequestModel.toDTO(request);
    // eslint-disable-next-line prefer-const
    let endpointPath = (Vue.$config.values as any)['endpoints-get-widget-host-config-async'] ?? 'core/WidgetHostConfigs';
    const response = await service.get<any>(endpointPath, {
      query: {
        isDebug: requestDTO.isDebug,
        isActive: requestDTO.isActive,
        searchCriteria: requestDTO.searchCriteria,
        'paging.CurrentPage': requestDTO['paging.CurrentPage'],
        'paging.PageSize': requestDTO['paging.PageSize'],
        'paging.IncludeCount': requestDTO['paging.IncludeCount'],
        'paging.NoPaging': requestDTO['paging.NoPaging'],
      },
      ...config,
    });
    const dto = response.data.result;
    return wrapResponseWithDataRecord(WidgetHostConfigPagingResultModel.toModel(dto));
  },
  /**  */
  async createWidgetHostConfig(request: CreateWidgetHostConfigRequestModel, config?: RequestConfig) {
    const requestDTO = CreateWidgetHostConfigRequestModel.toDTO(request);
    // eslint-disable-next-line prefer-const
    let endpointPath = (Vue.$config.values as any)['endpoints-create-widget-host-config'] ?? 'core/WidgetHostConfigs';
    const response = await service.post<any>(endpointPath, {
      body: {
        name: requestDTO.name,
        hostKey: requestDTO.hostKey,
        loaderUrl: requestDTO.loaderUrl,
        allowedReferers: requestDTO.allowedReferers,
        languageIso2: requestDTO.languageIso2,
        locale: requestDTO.locale,
        entryPoint: requestDTO.entryPoint,
        navigation: requestDTO.navigation,
        startParameters: requestDTO.startParameters,
        apiKey: requestDTO.apiKey,
        isDebug: requestDTO.isDebug,
        isActive: requestDTO.isActive,
      },
      ...config,
    });
  },
  /**  */
  async getWidgetHostConfigByIdAsync(request: GetWidgetHostConfigByIdAsyncRequestModel, config?: RequestConfig) {
    const requestDTO = GetWidgetHostConfigByIdAsyncRequestModel.toDTO(request);
    // eslint-disable-next-line prefer-const
    let endpointPath = (Vue.$config.values as any)['endpoints-get-widget-host-config-by-id-async'] ?? 'core/WidgetHostConfigs/{id}';
    endpointPath = endpointPath.replace(/\{id\}/g, `${requestDTO.id}`);
    const response = await service.get<any>(endpointPath, {
      ...config,
    });
    const dto = response.data.result;
    return wrapResponseWithDataRecord(WidgetHostConfigModel.toModel(dto));
  },
  /**  */
  async updateWidgetHostConfig(request: UpdateWidgetHostConfigRequestModel, config?: RequestConfig) {
    const requestDTO = UpdateWidgetHostConfigRequestModel.toDTO(request);
    // eslint-disable-next-line prefer-const
    let endpointPath = (Vue.$config.values as any)['endpoints-update-widget-host-config'] ?? 'core/WidgetHostConfigs/{id}';
    endpointPath = endpointPath.replace(/\{id\}/g, `${requestDTO.id}`);
    const response = await service.put<any>(endpointPath, {
      body: {
        id: requestDTO.id,
        links: requestDTO.links,
        creatorId: requestDTO.creatorId,
        creatorName: requestDTO.creatorName,
        created: requestDTO.created,
        modifierId: requestDTO.modifierId,
        modifierName: requestDTO.modifierName,
        modified: requestDTO.modified,
        name: requestDTO.name,
        hostKey: requestDTO.hostKey,
        loaderUrl: requestDTO.loaderUrl,
        allowedReferers: requestDTO.allowedReferers,
        languageIso2: requestDTO.languageIso2,
        locale: requestDTO.locale,
        entryPoint: requestDTO.entryPoint,
        navigation: requestDTO.navigation,
        startParameters: requestDTO.startParameters,
        apiKey: requestDTO.apiKey,
        isDebug: requestDTO.isDebug,
        isActive: requestDTO.isActive,
        textContentScope: requestDTO.textContentScope,
      },
      ...config,
    });
  },
  /**  */
  async deleteWidgetHostConfig(request: DeleteWidgetHostConfigRequestModel, config?: RequestConfig) {
    const requestDTO = DeleteWidgetHostConfigRequestModel.toDTO(request);
    // eslint-disable-next-line prefer-const
    let endpointPath = (Vue.$config.values as any)['endpoints-delete-widget-host-config'] ?? 'core/WidgetHostConfigs/{id}';
    endpointPath = endpointPath.replace(/\{id\}/g, `${requestDTO.id}`);
    const response = await service.delete<any>(endpointPath, {
      ...config,
    });
    const result = response?.data?.result ?? response?.data;
    return wrapResponseWithDataRecord(result as number);
  },
});
